export const VARIABLE_TYPE = 'ENV_VAR';
export const FILE_TYPE = 'FILE';
export const ALL_SCOPE = 'ALL';
export const SCHEDULES_PER_PAGE = 50;
export const DEFAULT_SORT_VALUE = 'ID_DESC';

export const TH_DESCRIPTION_TEST_ID = { 'data-testid': 'pipeline-schedules-description-sort' };
export const TH_TARGET_TEST_ID = { 'data-testid': 'pipeline-schedules-target-sort' };
export const TH_NEXT_TEST_ID = { 'data-testid': 'pipeline-schedules-next-sort' };

export const TABLE_SORT_STORAGE_KEY = 'pipeline_schedule_table_sort';
